module.exports = global["lodash"] = require("-!./lodash.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?lodash!./~/lodash/lodash.js-exposed
// module id = 99
// module chunks = 0